import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  /** Child components (PageHeaderLabel, PageHeaderCommandWell) */
  children: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
}

/**
 * PageHeader - Container component for page headers
 *
 * Provides consistent styling (border, background, padding) and
 * flex layout for label and command sections.
 *
 * @example
 * <PageHeader>
 *   <PageHeaderLabel title="Photos" icon={<PhotoIcon />} />
 *   <PageHeaderCommandWell>
 *     <Button>Upload</Button>
 *   </PageHeaderCommandWell>
 * </PageHeader>
 */
export function PageHeader({ children, className }: PageHeaderProps) {
  return (
    <header className={cn('border-b border-border bg-surface-1 px-6 py-4', className)}>
      <div className="flex items-center justify-between">{children}</div>
    </header>
  );
}
